import { render } from "./DashoboardListWrap.vue?vue&type=template&id=afdd968e"
import script from "./DashoboardListWrap.vue?vue&type=script&lang=js"
export * from "./DashoboardListWrap.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__